
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-filters",
      function () {
        return require("private-next-pages/ai-filters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-filters"])
      });
    }
  